// extracted by mini-css-extract-plugin
export default {"container":"TablePrint_container__zpprp"};